exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#addQuestionButton[data-v-4ef75c3e] {\n  margin-bottom: 30px;\n}\n.question_drag_icon[data-v-4ef75c3e]:hover {\n  cursor: grab;\n}\n", ""]);

// exports
